import { ApiClient } from '../helpers/api-client/ApiClient'
import { ResponseStatuses } from '../enums/ResponseStatuses'

export default function blocked ({ next, nextMiddleware }) {
  const handleResponse = response => {
    if (response.status !== 200) {
      return next('/')
    }

    const responseData = response.data
    const isBlocked = responseData && responseData.status === ResponseStatuses.Fail

    if (isBlocked) {
      return nextMiddleware()
    }

    return next('/')
  }

  return ApiClient.checkAccess()
    .then(response => handleResponse(response))
}
